export default "__VITE_ASSET__e5886c8a__"